'use strict';

const animateCounter = (element) => {
  const target = Number.parseInt(element.dataset.counterTarget || '0', 10);
  const prefix = element.dataset.counterPrefix || '';
  const suffix = element.dataset.counterSuffix || '';
  const duration = 1400;
  const startTime = performance.now();

  const tick = (now) => {
    const progress = Math.min((now - startTime) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    const value = Math.floor(eased * target);
    element.textContent = `${prefix}${value}${suffix}`;

    if (progress < 1) {
      requestAnimationFrame(tick);
    } else {
      element.textContent = `${prefix}${target}${suffix}`;
    }
  };

  requestAnimationFrame(tick);
};

const init = () => {
  const counters = Array.from(document.querySelectorAll('.js-counter-value'));
  if (!counters.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      animateCounter(entry.target);
      obs.unobserve(entry.target);
    });
  }, {threshold: 0.35});

  counters.forEach((counter) => observer.observe(counter));
};

export default {init};
